function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Created by pzf on 18/9/1.
 *
 */

/* eslint func-names: 1 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { LocaleReceiver, Icon, Tag } from 'mkui-fd';
import { isEmpty } from '../_util/stringUtils';
import defaultLocale from "../locale-provider/default";
import PopeditTrigger from './PopeditTrigger';
import { popEditPropTypes, popEditDefaultPropTypes } from './PropTypes';
import { getDataSource, isMultiple, updateChoosed, getText, buildChangeValue, removeChoosed } from './util';
import { deepClone } from '../_util/clone';

var Popedit = /*#__PURE__*/function (_React$Component) {
  _inherits(Popedit, _React$Component);

  _createClass(Popedit, null, [{
    key: "getDerivedStateFromProps",

    /** *******************static************************** */
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        var choosed = [];
        updateChoosed(choosed, nextProps.value);
        return {
          choosed: choosed
        };
      }

      if ('data' in nextProps) {
        return {
          data: deepClone(nextProps.data)
        };
      }

      return null;
    }
    /** *******************life cycle************************** */

  }]);

  function Popedit(props) {
    var _this;

    _classCallCheck(this, Popedit);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popedit).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "selectHandle", function (items) {
      var _this2;

      var _this$props = _this.props,
          multiple = _this$props.multiple,
          tagClosable = _this$props.tagClosable;

      if (!multiple) {
        _this.setState({
          choosed: items,
          open: false
        });
      } else {
        if (tagClosable) {
          _this.setState({
            choosed: items
          });
        } else {
          _this.setState({
            choosed: items,
            open: false
          });
        }
      }

      for (var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        others[_key - 1] = arguments[_key];
      }

      (_this2 = _this).fireChange.apply(_this2, [items].concat(others));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPopedit", function (contextLocale) {
      var _rootCls;

      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          disabled = _this$props2.disabled,
          prefixCls = _this$props2.prefixCls,
          inputClassName = _this$props2.inputClassName,
          theme = _this$props2.theme,
          size = _this$props2.size,
          allowClear = _this$props2.allowClear,
          placement = _this$props2.placement,
          getPopupContainer = _this$props2.getPopupContainer;
      var _this$state = _this.state,
          open = _this$state.open,
          value = _this$state.value,
          data = _this$state.data,
          choosed = _this$state.choosed;

      var ctrlNode = _this.renderTopControlNode(contextLocale);

      var popupElement = _this.getDropdownElement();

      var rootCls = (_rootCls = {}, _defineProperty(_rootCls, inputClassName, 1), _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "".concat(prefixCls, "-open"), open), _defineProperty(_rootCls, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_rootCls, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_rootCls, "".concat(prefixCls, "-li"), !theme || theme === 'default'), _defineProperty(_rootCls, "".concat(prefixCls, "-clearable"), allowClear && !disabled && choosed.length > 0), _rootCls);
      return React.createElement(PopeditTrigger, {
        multiple: multiple,
        disabled: disabled,
        value: value,
        onDropdownVisibleChange: function onDropdownVisibleChange(visible) {
          return _this.onDropdownVisibleChangeHandle(visible);
        },
        popup: popupElement,
        data: data,
        visible: open,
        placement: placement,
        getPopupContainer: getPopupContainer
      }, React.createElement("div", {
        className: rootCls
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-selection\n            ").concat(prefixCls, "-selection--").concat(multiple ? 'multiple' : 'single')
      }, ctrlNode, _this.renderIcon())));
    });

    _this.state = _this.getInitState(props);
    _this.panelRef = React.createRef();
    return _this;
  }
  /** *******************handle************************** */

  /**
   * 下拉箭头点击触发
   * @param e
   */


  _createClass(Popedit, [{
    key: "iconClickHandle",
    value: function iconClickHandle(e) {
      e.stopPropagation();
      e.preventDefault();
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          open = _this$props3.open;

      if (!disabled) {
        this.toggleDropdown(!open);
      }
    }
    /**
     * 下拉面板中选择选项后触发
     * @param items Array
     */

  }, {
    key: "removeHandle",

    /**
     * 从已选项中删除，只有在多选时可用
     * @param item
     */
    value: function removeHandle(e, item) {
      e.preventDefault();
      e.stopPropagation();
      var choosed = this.state.choosed;
      removeChoosed(choosed, item);
      this.setState({
        choosed: choosed
      });
      this.fireChange(choosed); // 抽象类测试时报错

      if (this.panelRef.current && this.panelRef.current.removeChoose) {
        this.panelRef.current.removeChoosed(item);
      }
    }
  }, {
    key: "clearHandle",
    value: function clearHandle(e) {
      e.stopPropagation();
      e.preventDefault();
      this.setState({
        choosed: []
      });
      this.fireChange([]);
    }
  }, {
    key: "onDropdownVisibleChangeHandle",
    value: function onDropdownVisibleChangeHandle(open) {
      this.toggleDropdown(open);
    }
    /** *******************inner method************************** */

  }, {
    key: "getInitState",
    value: function getInitState(props) {
      var value = this.props.value;
      var choosed = [];

      if (value) {
        updateChoosed(choosed, value);
      }

      return {
        open: false,
        loaded: false,
        choosed: choosed,
        data: getDataSource(props)
      };
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown(open) {
      var loaded = this.state.loaded;
      var lazyLoad = this.props.lazyLoad;

      if (!lazyLoad) {
        this.setOpenState(open);
      } else {
        if (!loaded) {
          this.fetchData();
          this.setState({
            open: open,
            loading: true
          });
        } else {
          this.setOpenState(open);
        }
      }
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this3 = this;

      var api = this.props.api;
      api().then(function (data) {
        _this3.setState({
          data: data,
          loaded: true,
          loading: false
        });
      });
    }
  }, {
    key: "setOpenState",
    value: function setOpenState(open) {
      this.setState({
        open: open
      });
    }
  }, {
    key: "fireChange",
    value: function fireChange(choosed) {
      var _this$props4 = this.props,
          multiple = _this$props4.multiple,
          onChange = _this$props4.onChange;
      var values = buildChangeValue(choosed, multiple);

      for (var _len2 = arguments.length, others = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        others[_key2 - 1] = arguments[_key2];
      }

      onChange.apply(void 0, [values].concat(others));
    }
  }, {
    key: "getPlaceholderElement",
    value: function getPlaceholderElement(contextLocale) {
      var choosed = this.state.choosed;
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          disabled = _this$props5.disabled;
      var placeholder = this.props.placeholder;

      if (disabled && !choosed.length) {
        placeholder = contextLocale.none;
      } else {
        placeholder = isEmpty(placeholder) ? contextLocale.placeholder : placeholder;
      }

      if (placeholder) {
        return React.createElement("div", {
          className: "".concat(prefixCls, "-selection__placeholder"),
          unselectable: "on"
        }, placeholder);
      }

      return null;
    }
  }, {
    key: "getDropdownElement",
    value: function getDropdownElement() {
      var _this$props6 = this.props,
          multiple = _this$props6.multiple,
          children = _this$props6.children,
          prefixCls = _this$props6.prefixCls,
          value = _this$props6.value;
      var data = this.state.data;
      var loading = this.state.loading;
      var selected;

      if (multiple) {
        selected = value;
      } else {
        if (value) {
          selected = [value];
        } else {
          selected = [];
        }
      }

      var childrenWithProps = React.cloneElement(children, {
        ref: this.panelRef,
        data: data,
        onSelect: this.selectHandle,
        multiple: multiple,
        selected: selected
      });

      if (loading) {
        return React.createElement(Icon, {
          type: "loading",
          className: "".concat(prefixCls, "-loading")
        });
      } else {
        return childrenWithProps;
      }
    }
    /** *******************render method************************** */

  }, {
    key: "renderTopControlNode",
    value: function renderTopControlNode(contextLocale) {
      var _this4 = this;

      var choosed = this.state.choosed;
      var _this$props7 = this.props,
          disabled = _this$props7.disabled,
          prefixCls = _this$props7.prefixCls,
          tagClosable = _this$props7.tagClosable;
      var multiple = isMultiple(this.props);
      var className = "".concat(prefixCls, "-selection__rendered");
      var innerNode = null;

      if (choosed.length) {
        if (multiple) {
          innerNode = choosed.map(function (item) {
            return React.createElement(Tag, {
              key: item.code,
              closable: !disabled && tagClosable,
              onClose: function onClose(e) {
                _this4.removeHandle(e, item);
              }
            }, getText(item));
          });
        } else {
          var text = getText(choosed[0]);
          var selectedValue = React.createElement("div", {
            key: "value",
            className: "".concat(prefixCls, "-selection-selected-value"),
            title: text
          }, text);
          innerNode = [selectedValue];
        }
      }

      return React.createElement("div", {
        className: className
      }, !innerNode ? this.getPlaceholderElement(contextLocale) : innerNode);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var _this5 = this;

      var _this$props8 = this.props,
          icon = _this$props8.icon,
          prefixCls = _this$props8.prefixCls;
      var downIcon = React.createElement(Icon, {
        type: "down",
        className: "".concat(prefixCls, "-selection-icon"),
        onClick: function onClick(event) {
          return _this5.iconClickHandle(event);
        }
      });
      var clearIcon = React.createElement(Icon, {
        type: "close-circle",
        theme: "filled",
        className: "".concat(prefixCls, "-selection-clear"),
        onClick: function onClick(event) {
          return _this5.clearHandle(event);
        }
      });
      return React.createElement(Fragment, null, icon || downIcon, clearIcon);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(LocaleReceiver, {
        componentName: "Popedit",
        defaultLocale: defaultLocale.Popedit
      }, this.renderPopedit);
    }
  }]);

  return Popedit;
}(React.Component);

_defineProperty(Popedit, "propTypes", _extends(popEditPropTypes, {
  prefixCls: PropTypes.string
}));

_defineProperty(Popedit, "defaultProps", _extends(popEditDefaultPropTypes, {
  prefixCls: 'mkui-popedit'
}));

export default Popedit;
//# sourceMappingURL=Popedit.js.map
